import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visita-tarea-serie',
  templateUrl: './visita-tarea-serie.component.html',
  styleUrls: ['./visita-tarea-serie.component.css']
})
export class VisitaTareaSerieComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
